import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"matrix(2,0,0,2,0,0)\"><defs></defs><path d=\"M2.5,5.5v13c0,2.21,4.254,4,9.5,4s9.5-1.79,9.5-4V5.5Z\" style=\"fill:#ffcd32;\"></path><path d=\"M12,5.5H2.5v13c0,2.21,4.254,4,9.5,4Z\" style=\"fill:#313131;\"></path><path class=\"c\" d=\"M2.5,5.5v13c0,2.21,4.254,4,9.5,4s9.5-1.79,9.5-4V5.5\"></path><ellipse cx=\"12.001\" cy=\"5.501\" rx=\"9.5\" ry=\"4\" style=\"stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;fill:#ffcd32;\"></ellipse><path class=\"c\" d=\"M21.5,9.5c0,2.21-4.254,4-9.5,4s-9.5-1.79-9.5-4\"></path><path class=\"c\" d=\"M21.5,14c0,2.21-4.254,4-9.5,4s-9.5-1.79-9.5-4\"></path></g>", 1)
  ])))
}
export default { render: render }